import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { IssuesPage } from '@/features/site/issues-page';

const searchSchema = z.object({
  issue: z.string().optional().catch(undefined),
  new: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/issues')({
  validateSearch: searchSchema,
  component: IssuesRoute,
});

function IssuesRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <IssuesPage projectId={projectId} issueId={search.issue} create={search.new} />;
}
